export default __webpack_public_path__ + "static/kiss-f1dc641121c29cefa65a5aa0b30a73d2.gif";